import React from 'react'
import {analytics} from '../../services'
import CustomInput from '../../components/DesignSystem/CustomInput'
import MaskedInput from '../../components/DesignSystem/MaskedInput'
import {
  Box,
  Card,
  CardHeader,
  CardBody,
  Heading,
  Text,
  Button,
  Center,
  Alert,
  AlertIcon,
  AlertDescription,
} from '@chakra-ui/react'
class verification extends React.Component {
  constructor(props) {
    super(props)
    this.emailInputRef = React.createRef()

    this.state = {
      emailError: false,
      isValidPassword: false,
      phoneError: false,
      isLoading: false,
    }

    this.handleButtonClick = this.handleButtonClick.bind(this)
    this.handlePasswordValidationChange =
      this.handlePasswordValidationChange.bind(this)
  }
  handlePasswordValidationChange(isValid) {
    this.setState({isValidPassword: isValid})
  }
  checkEmail = input => {
    return /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/.test(
      input
    )
  }

  handleInputBlur() {
    if (this.checkEmail(this.props.email)) {
      this.setState({emailError: false})
    } else if (this.props.email !== '') {
      this.setState({emailError: true})
    }
  }
  handlePhoneInputBlur() {
    if (
      this.props.mobile.length > 13 ||
      this.props.mobile === '(' ||
      this.props.mobile === ''
    ) {
      this.setState({phoneError: false})
    } else {
      this.setState({phoneError: true})
    }
  }

  singleUpdate() {
    if (this.props.currentStep === 3) {
      analytics.track('Verification', 'Wizard', {page: 3})

      window.scrollTo(0, 0)
      //Allows for use on single DidUpdate
      this.singleUpdate = function () {}
    }
  }

  handleButtonClick() {
    if (this.emailInputRef.current) {
      this.emailInputRef.current.focus()
    }
  }

  componentDidMount() {
    this.handleInputBlur()
  }
  componentDidUpdate() {
    if (this.props.emailIsUnique === false && this.state.isLoading) {
      this.setState({isLoading: false})
    }
    this.singleUpdate()
  }

  render() {
    if (this.props.currentStep !== 3) {
      return null
    }

    const isButtonEnabled =
      !this.state.emailError &&
      this.state.isValidPassword &&
      this.checkEmail(this.props.email) &&
      (this.props.mobile.length > 13 ||
        this.props.mobile === '(' ||
        this.props.mobile === '')

    const showVerificationBox = this.checkEmail(this.props.email)

    return (
      <Box bg="#EBF9FF">
        <Center>
          <Card mt={10} mb={10} maxW={"480px"} boxShadow="xl" p={10}>
            <CardHeader mb={-5}>
              <Text textStyle="t6" as="b" color="pb100">
                Complete your profile
              </Text>
            </CardHeader>
            <CardBody>
              <Text textStyle="b2">
                We found your account! Enter the information below to complete
                your profile.
              </Text>
              <Box mt={10} mb={6}>
                <Heading size="md">
                  {" "}
                  {this.props.firstName + " " + this.props.lastName}
                </Heading>
              </Box>
              {this.props.emailIsUnique === false && (
                <Box>
                  <Alert mt={5} variant="error" status="error">
                    {" "}
                    <AlertIcon />
                    <Box>
                      <AlertDescription>
                        This email is already linked to another account. Please
                        use a different email.
                      </AlertDescription>
                    </Box>
                  </Alert>
                </Box>
              )}
              <Box mt={8}>
                <label htmlFor="email" className="visually-hidden">
                  Email
                </label>
                <CustomInput
                  inputRef={this.emailInputRef}
                  id="email"
                  name="email"
                  inputTitle="Email"
                  isRequired
                  isInvalid={this.state.emailError}
                  error={this.state.emailError && "Please enter a valid email"}
                  description="You'll use this email to sign in to your account."
                  onChange={this.props.handleChange}
                  value={this.props.email}
                  onBlur={() => this.handleInputBlur()}
                  maxLength={70}
                ></CustomInput>
              </Box>

              <Box mt={8}>
                <label htmlFor="password" className="visually-hidden">
                  Create a Password
                </label>
                <MaskedInput
                  inputTitle="Create a Password"
                  isRequired
                  id="password"
                  name="password"
                  type="password"
                  toggleButton
                  value={this.props.password}
                  onChange={this.props.handleChange}
                  onPasswordValidationChange={
                    this.handlePasswordValidationChange
                  }
                ></MaskedInput>
              </Box>
              <Box mt={8}>
                <label htmlFor="mobile" className="visually-hidden">
                  Phone (optional)
                </label>
                <CustomInput
                  id="mobile"
                  name="mobile"
                  isInvalid={this.state.phoneError}
                  error={
                    this.state.phoneError && "Please enter a valid phone number"
                  }
                  inputTitle="Phone (optional)"
                  type="phone"
                  description="To keep you up-to-date with our latest promotions"
                  value={this.props.mobile}
                  onChange={(event) => {
                    this.props.handleChange(event);
                  }}
                  onBlur={() => this.handlePhoneInputBlur()}
                />
              </Box>

              {showVerificationBox && (
                <Center>
                  <Box maxW={"100%"} bg="#F5F5F5" p={5} mt={8}>
                    <Box textAlign="center">
                      Verification email will be sent to{" "}
                      <strong>{this.props.email}</strong>
                    </Box>
                    <Box>
                      <Button
                        mt={3}
                        variant="outline"
                        size="xs"
                        onClick={this.handleButtonClick}
                        w="100%"
                      >
                        Change
                      </Button>
                    </Box>
                  </Box>
                </Center>
              )}
            </CardBody>
            <Box>
              <Center>
                <Button
                  w="100%"
                  m={4}
                  mb={6}
                  mt={6}
                  onClick={() => {
                    this.setState({ isLoading: true });
                    this.props.onContinue();
                  }}
                  isDisabled={!isButtonEnabled}
                  isLoading={this.state.isLoading}
                >
                  Continue
                </Button>{" "}
              </Center>
            </Box>
          </Card>
        </Center>
      </Box>
    );
  }
}

export default verification
